<template>
  <div class="button-container">
    <button class="button" @click="openDialog" type="button">Idea Coach</button>
    <div @click="closeDialog" class="backdrop" v-if="showDialog">
      <IdeaCoachDialog :type="type" @hide="closeDialog" @submit="emitSubmit" />
    </div>
  </div>
</template>

<script>
import IdeaCoachDialog from "./IdeaCoachDialog";

export default {
  name: "IdeaCoach",
  props: {
    type: {
      type: String,
      default: "",
    },
  },
  components: { IdeaCoachDialog },
  data() {
    return {
      showDialog: false,
      suggestions: [],
    };
  },
  mounted() {},
  methods: {
    openDialog() {
      this.showDialog = true;
      this.$emit("idea")
    },
    closeDialog() {
      this.showDialog = false;
    },
    emitSubmit() {
      this.$emit("submit");
      this.closeDialog();
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../scss/main";

.button-container {
  width: 100%;
  display: flex;
  justify-content: center;
}

.button {
  background-color: $red-2;
  color: $white-1;
  border-radius: 3rem;
  padding: 0.5rem 1rem;
}

.backdrop {
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
